import '../../common/css/style.css';

// Короткий блок довіри одразу під героєм — цифри, які вже підтверджені
// текстом у розділі "Викладачі" (жодних вигаданих показників)

const STATS = [
  { value: '20+', label: 'років у танцях' },
  { value: '7+', label: 'років викладацького досвіду' },
  { value: '🏆', label: 'чемпіони та призери змагань' },
];

export const Stats = () => {
  return (
    <div className="stats-section">
      <div className="stats-strip">
        {STATS.map(({ value, label }) => (
          <div className="stat-item" key={label}>
            <span className="stat-value">{value}</span>
            <span className="stat-label">{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
